module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/lock-overturning-813648950d5ef04df04cf8d31ce42f8d.svg";